import { ReactNode } from 'react';

import { AppFormattedMessage } from '../../components/app-formatted-message/index';

export enum CompanySettingsCardTab {
  COMPANY_ADDRESS = 'address',
  COMPANY_BILLING_HISTORY = 'company-billing-history',
  COMPANY_DETAILS = 'details',
  COMPANY_PLAN_BILLING = 'plan-billing',
  // COMPANY_EQUITY = 'company-equity',
  TEAM = 'team',
}

export const companySettingsCardTitleMap: Record<CompanySettingsCardTab, ReactNode> = {
  [CompanySettingsCardTab.COMPANY_DETAILS]: <AppFormattedMessage id="DETAILS" />,
  [CompanySettingsCardTab.COMPANY_ADDRESS]: (
    <>
      <AppFormattedMessage id="ADDRESS" />
    </>
  ),
  [CompanySettingsCardTab.COMPANY_PLAN_BILLING]: <AppFormattedMessage id="PLAN_BILLING" />,
  [CompanySettingsCardTab.COMPANY_BILLING_HISTORY]: <AppFormattedMessage id="BILLING_HISTORY" />,
  // [CompanySettingsCardTab.COMPANY_EQUITY]: <AppFormattedMessage id="EQUITY_CAP_TABLE" />,
  [CompanySettingsCardTab.TEAM]: <AppFormattedMessage id="TEAM" />,
};

export const arrayOfCompanySettingsCardTitleMap = Object.entries(companySettingsCardTitleMap) as [
  CompanySettingsCardTab,
  string,
][];
